import { useEffect, useState } from "react";
import { Footer } from "./components/Footer";
import { FocusAreas } from "./components/FocusAreas";
import { HeroSection } from "./components/HeroSection";
import { PurposeSection } from "./components/PurposeSection";
import { content, getBrowserLanguage, Language } from "./content";
import "./App.css";

function App() {
  const [language, setLanguage] = useState<Language>(getBrowserLanguage);
  const copy = content[language];

  useEffect(() => {
    document.documentElement.lang = copy.htmlLang;
  }, [copy.htmlLang]);

  return (
    <main className="portal">
      <HeroSection copy={copy} language={language} onLanguageChange={setLanguage} />
      <PurposeSection copy={copy} />
      <FocusAreas copy={copy} />
      <Footer copy={copy} />
    </main>
  );
}

export default App;
